import { Dropdown, Nav } from 'react-bootstrap';
import React,{ useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../Hooks';
import { buscar } from '../../Utils/Buscar';
import ToolTip from '../ToolTip/Tooltip';
import { SvgComponent } from '../SvgComponent/SvgComponent';
import {LOGOUT, PONCHE, RECARGAR_PERFIL} from "../../Utils";

const Dp = Dropdown;
export function SettingsButton() {
  const [esEntrada, setEsEntrada] = useState(null);
  const [miCuenta, setMiCuenta] = useState(null);
  const consultaActualId = useRef();
  const navigate = useNavigate();
  const {usuario, TIENE_PERMISO} = useAuthentication();

  function manageGoTo(url) {
    navigate(url);
  }
  useEffect(() => {
    setEsEntrada(usuario?.PoncheEsEoS ?? false);
    setMiCuenta(TIENE_PERMISO("Citrus.Seguridad.MiCuenta.Visualizar"))
  },[usuario])
  function ponche(){
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const url =
          PONCHE
      buscar(url, {}).then((data) => {
        if (consultaId === consultaActualId.current) {
          setEsEntrada(data.usuario.PoncheEsEoS)
        }
      });
    };
    obtenerDatos();
  }

  function recargarPerfil(){
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;

      const url =
          RECARGAR_PERFIL
      buscar(url, {}).then((data) => {
        if (consultaId === consultaActualId.current) {
          window.location.reload();
        }
      });
    };
    obtenerDatos();
  }

  function cerrarSesion(){
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;
      const url =
          LOGOUT
      buscar(url, {}).then((data) => {
        if (consultaId === consultaActualId.current) {
          window.location.href = data.RedirectUrl;
        }
      });
    };
    obtenerDatos();
  }
  return (
    <React.Fragment>
      <Dp as={Nav.Item}>
        <Dp.Toggle as={Nav.Link} id="Dp-41471887333" className="buttonHover">
          <ToolTip placement="left" message="Configuración">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              fill="#77777A"
              height="33"
              viewBox="0 -960 960 960"
            >
              <path d="m400.693-100.001-18.077-120.231q-20.538-7-44.231-20.346-23.692-13.346-40.846-28.27l-111.846 50.923-79.922-141.306 101.077-74.384q-2-10.539-2.885-23-.885-12.462-.885-23 0-10.154.885-22.616t2.885-24.154l-101.077-74.769 79.922-140.152 111.461 50.154q18.308-14.924 41.231-28.078 22.924-13.154 43.847-19.538l18.461-121.231h158.614l18.077 120.615q22.077 8.154 44.154 20.231 22.077 12.077 39.769 28.001l113.384-50.154 79.538 140.152-102.615 74.308q2.769 11.923 3.462 24 .692 12.077.692 22.846 0 10.385-.885 22.154-.884 11.769-3.269 24.462l102.23 74.153-79.922 141.306-112.615-51.307q-18.692 15.692-40.346 28.962-21.654 13.269-43.577 19.654l-18.077 120.615H400.693Zm36.461-45.384h85.307L536.846-257q31.846-8 59.423-23.846 27.577-15.847 52.731-40.231l104.461 45.231 40-70.847L701-414.923q4-17.77 6.307-33.5 2.308-15.731 2.308-31.577 0-16.615-2-31.961T701-544.307l93.23-69-40-70.847-105.615 45.231q-21.077-23.692-50.846-41.769Q568-698.769 536.461-703l-13.615-111.615h-85.692l-13.231 111.231q-33.23 6.615-61.192 22.653-27.961 16.039-52.115 41.424L205.77-684.154l-40 70.847 92.461 67.846q-4.385 15.846-6.692 32.153-2.308 16.308-2.308 33.693 0 16.615 2.308 32.538 2.307 15.923 6.307 32.154l-92.076 68.23 40 70.847 104.461-44.847q24 24.385 52.154 40.231 28.154 15.846 61.154 23.846l13.615 111.231Zm41.692-221.924q47.076 0 79.884-32.807 32.807-32.808 32.807-79.884t-32.807-79.884q-32.808-32.807-79.884-32.807-46.692 0-79.691 32.807-33 32.808-33 79.884t33 79.884q32.999 32.807 79.691 32.807ZM480-480Z" />
            </svg>
          </ToolTip>
        </Dp.Toggle>
        <Dp.Menu alignRight aria-labelledby="navbarDpMenuLink">
          {(TIENE_PERMISO("Citrus.Seguridad.Usuario.Ponche") || (usuario?.Compania.UsaNomina ?? false)) && (
            <Dp.Item
              as={Link}
              onClick={(e) => {
                e.preventDefault();
                ponche();
              }}
            >
              <SvgComponent
                height="28"
                width="28"
                iconName="registrar entrada"
                fill="#2f2f2f"
                style={{ marginRight: "8px" }}
              />
              {esEntrada ? "Registrar Entrada" : "Registrar Salida"}
            </Dp.Item>
          )}
          <Dp.Item
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              recargarPerfil();
            }}
          >
            <SvgComponent
              height="28"
              width="28"
              iconName="refresh"
              fill="#2f2f2f"
              style={{ marginRight: "8px" }}
            />
            Recargar Perfil
          </Dp.Item>
          <Dp.Item
            as={Link}
            to="/Seguridad/cambio_password.aspx"
            onClick={() => manageGoTo("/Seguridad/cambio_password.aspx")}
          >
            <SvgComponent
              height="28"
              width="28"
              iconName="cambiar contrasena"
              fill="#2f2f2f"
              style={{ marginRight: "8px" }}
            />
            Cambiar Contraseña
          </Dp.Item>
          {miCuenta && (
            <Dp.Item
              as={Link}
              to="App/Seguridad/MiCuenta"
              onClick={() => manageGoTo("App/Seguridad/MiCuenta")}
            >
              <SvgComponent
                height="28"
                width="28"
                iconName="mi cuenta"
                fill="#2f2f2f"
                style={{ marginRight: "8px" }}
              />
              Mi Cuenta
            </Dp.Item>
          )}
          <Dp.Item
            as={Link}
            onClick={(e) => {
              e.preventDefault();
              cerrarSesion();
            }}
          >
            <SvgComponent
              height="28"
              width="28"
              iconName="cerrar sesion"
              fill="#2f2f2f"
              style={{ marginRight: "8px" }}
            />
            Cerrar Sesión
          </Dp.Item>
        </Dp.Menu>
      </Dp>
    </React.Fragment>
  );
}
